import { useEffect } from 'react'
import useSendDataToClarity from './useSendDataToClarity'

const useSendUserMetadataToClarity = currentUser => {
  const sendDataToClarity = useSendDataToClarity()

  useEffect(() => {
    const sendUserDataToClarity = () => {
      if (window.clarity && currentUser) {
        sendDataToClarity('email', currentUser.email)
        sendDataToClarity('audience', currentUser.category)
        window.clarity('identify', 'id', currentUser.id)
      }
    }

    sendUserDataToClarity()
  }, [sendDataToClarity, currentUser])
}

export default useSendUserMetadataToClarity
